import React, { useState } from 'react';

const MoreCredit = ({ onNext, answers, stepKey }) => {
  const [selectedAnswer, setSelectedAnswer] = useState(answers && answers[stepKey] ? answers[stepKey] : null);

  const handleClick = (value) => {
    setSelectedAnswer(value);
    onNext(value);
  };

  return (
    <>
      <div className="qs-card__head"><h2 className="qs-card__title">Offered More Credit While Struggling?</h2></div>
      <div className="qs-card__body">
        <p className="qs-card__sub">Were you offered further credit (e.g. top-ups, refinancing) before repaying the original car loan?</p>
        <div className="qs-actions">
          <button 
            type="button" 
            className={`qs-btn qs-btn--yes ${selectedAnswer == 477 ? 'btn-active' : ''}`}
            onClick={() => handleClick(477)}>
            Yes
          </button>
          <button 
            type="button" 
            className={`qs-btn qs-btn--no ${selectedAnswer == 478 ? 'btn-active' : ''}`}
            onClick={() => handleClick(478)}>
            No
          </button>
        </div>
      </div>
    </>
  );
};

export default MoreCredit;
